import { Box, styled, Typography } from '@mui/material'
import { colors } from '@/Theme/LegacyTheme'
import { KeyValueStripedListProps, KeyValueStripedListRow } from '@/types/UI'

const fields: { label: string; key: keyof KeyValueStripedListRow }[] = [
  { label: 'TYPE', key: 'type' },
  { label: 'COOKIE', key: 'cookie' },
  { label: 'PURPOSE', key: 'purpose' },
  { label: 'DURATION', key: 'duration' }
]

export const TypographyStyled = styled(Typography)(({ theme }) => ({
  minWidth: '90px',
  [theme.breakpoints.down('sm')]: {
    textAlign: 'left',
    width: '100%',
    minWidth: 0
  }
})) as typeof Typography

const KeyValueStripedList = ({ data, fontVariant = 'body1' }: KeyValueStripedListProps) => {
  return (
    <Box mb={2}>
      {data.map((row, index) => (
        <Box
          key={row.cookie}
          component="dl"
          sx={{
            m: 0,
            p: 3,
            background: index % 2 ? colors.grey : 'white'
          }}
        >
          {fields.map(({ label, key }) => (
            <Box
              key={label}
              sx={(theme) => ({
                display: 'flex',
                flexShrink: 1,
                gap: theme.spacing(3),
                py: theme.spacing(1),
                [theme.breakpoints.down('sm')]: {
                  display: 'block'
                }
              })}
            >
              <TypographyStyled
                component="dt"
                variant={fontVariant}
                sx={{ m: 0, p: 0, textAlign: 'right', fontWeight: 700 }}
              >
                {label}
              </TypographyStyled>
              <TypographyStyled
                component="dd"
                variant={fontVariant}
                sx={{ m: 0, p: 0, minWidth: 0 }}
              >
                {row[key]}
              </TypographyStyled>
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  )
}

export default KeyValueStripedList
